<template>
    <div class="content">
        <p class="has-text-weight-semibold mb-2">
            {{ translate("page.events.no_events_helpful_resources") }}
        </p>
        <ul class="has-text-centered is-size-7-mobile" style="list-style: none; padding-left: 0">
            <li class="mb-2">
                <a :href="urls.helpCenter().creatingNewEvent()" target="_blank" class="has-text-link">
                    <span class="icon">
                        <i class="fas fa-book-open"></i>
                    </span>
                    <span>{{ translate("page.events.help_creating_new_event") }}</span>
                    <span class="icon">
                        <i class="fas fa-external-link-alt"></i>
                    </span>
                </a>
            </li>
            <li>
                <a :href="urls.helpCenter().categoriesManagement()" target="_blank" class="has-text-link">
                    <span class="icon">
                        <i class="fas fa-book-open"></i>
                    </span>
                    <span>{{ translate("page.events.help_categories_management") }}</span>
                    <span class="icon">
                        <i class="fas fa-external-link-alt"></i>
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../Common/translations";
    import urls from "../Urls/urls";
</script>
